export const PMFIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="59" height="77" viewBox="0 0 59 77" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M50.354 1.60449H8.64567C5.10184 1.60449 2.229 4.47733 2.229 8.02116V68.9795C2.229 72.5233 5.10184 75.3962 8.64567 75.3962H50.354C53.8978 75.3962 56.7707 72.5233 56.7707 68.9795V8.02116C56.7707 4.47733 53.8978 1.60449 50.354 1.60449Z"
        fill="#C4F0EB"
      />
      <path
        d="M50.354 67.0544H8.64567C6.94386 67.0544 5.31176 66.3783 4.1084 65.175C2.90504 63.9716 2.229 62.3395 2.229 60.6377V68.9794C2.229 70.6812 2.90504 72.3133 4.1084 73.5166C5.31176 74.72 6.94386 75.396 8.64567 75.396H50.354C52.0558 75.396 53.6879 74.72 54.8913 73.5166C56.0946 72.3133 56.7707 70.6812 56.7707 68.9794V60.6377C56.7707 62.3395 56.0946 63.9716 54.8913 65.175C53.6879 66.3783 52.0558 67.0544 50.354 67.0544Z"
        fill="#00E6CA"
      />
      <path
        d="M50.354 1.60449H8.64567C5.10184 1.60449 2.229 4.47733 2.229 8.02116V68.9795C2.229 72.5233 5.10184 75.3962 8.64567 75.3962H50.354C53.8978 75.3962 56.7707 72.5233 56.7707 68.9795V8.02116C56.7707 4.47733 53.8978 1.60449 50.354 1.60449Z"
        stroke="black"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.5415 8.02051H13.4582C12.5722 8.02051 11.854 8.73872 11.854 9.62467V35.2913C11.854 36.1773 12.5722 36.8955 13.4582 36.8955H45.5415C46.4275 36.8955 47.1457 36.1773 47.1457 35.2913V9.62467C47.1457 8.73872 46.4275 8.02051 45.5415 8.02051Z"
        fill="#00E6CA"
      />
      <path
        d="M13.4582 8.02051C13.0327 8.02051 12.6247 8.18952 12.3239 8.49036C12.023 8.7912 11.854 9.19922 11.854 9.62467V35.2913C11.854 35.7168 12.023 36.1248 12.3239 36.4257C12.6247 36.7265 13.0327 36.8955 13.4582 36.8955H13.5865L42.4615 8.02051H13.4582Z"
        fill="#C4F0EB"
      />
      <path
        d="M45.5415 8.02051H13.4582C12.5722 8.02051 11.854 8.73872 11.854 9.62467V35.2913C11.854 36.1773 12.5722 36.8955 13.4582 36.8955H45.5415C46.4275 36.8955 47.1457 36.1773 47.1457 35.2913V9.62467C47.1457 8.73872 46.4275 8.02051 45.5415 8.02051Z"
        stroke="black"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.5418 54.5417C47.3137 54.5417 48.7502 53.1052 48.7502 51.3333C48.7502 49.5614 47.3137 48.125 45.5418 48.125C43.7699 48.125 42.3335 49.5614 42.3335 51.3333C42.3335 53.1052 43.7699 54.5417 45.5418 54.5417Z"
        fill="white"
        stroke="black"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.5418 67.3747C47.3137 67.3747 48.7502 65.9383 48.7502 64.1663C48.7502 62.3944 47.3137 60.958 45.5418 60.958C43.7699 60.958 42.3335 62.3944 42.3335 64.1663C42.3335 65.9383 43.7699 67.3747 45.5418 67.3747Z"
        fill="white"
        stroke="black"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.479 65.7705C26.7947 65.7705 31.104 61.4612 31.104 56.1455C31.104 50.8298 26.7947 46.5205 21.479 46.5205C16.1633 46.5205 11.854 50.8298 11.854 56.1455C11.854 61.4612 16.1633 65.7705 21.479 65.7705Z"
        fill="#00E6CA"
        stroke="black"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.9857 30.6588L19.875 14.4375"
        stroke="black"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.0835 36.8962C23.0835 35.1944 23.7595 33.5622 24.9629 32.3589C26.1663 31.1555 27.7984 30.4795 29.5002 30.4795C31.202 30.4795 32.8341 31.1555 34.0374 32.3589C35.2408 33.5622 35.9168 35.1944 35.9168 36.8962H23.0835Z"
        fill="#00E6CA"
        stroke="black"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.479 43.4629V68.9788"
        stroke="black"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
